import { createFileRoute } from '@tanstack/react-router';
import { PlansListPage } from '@/modules/plans/pages/PlansListPage';

export const Route = createFileRoute('/dashboard/plans/')({
  component: PlansListPage,
});
